<!-- Tabella con lista filtrata -->
<div>
  <ds-table
    [columns]="tableColumns()"
    [options]="tableOptions()"
    [sourceList]="tableIstatCustomers()"
    [(selectedRecords)]="tableSelectedRecords"
    [isLoading]="loading()"
  />
</div>

<ng-template #istatCompleteStatus let-value="value" let-row="row">
  <ds-status-label
    [text]="value ? translation.status.completeness.complete : translation.status.completeness.incomplete"
    [status]="value ? 'confirm' : 'danger'"
    [tooltipTrigger]="value ? 'hover' : 'click'"
    [tooltip]="!value ? tooltipIstatCompleteStatus : undefined"
    [tooltipContext]="{ row: row }"
    [disabled]="value"
    showIcon
    small
  />
</ng-template>

<ng-template #istatSendStatus let-value="value" let-row="row">
  @let istatSendStatus = getIstatSendStatus(value);
  @if (istatSendStatus) {
    <ds-status-label
      [text]="istatSendStatus.text"
      [status]="istatSendStatus.status"
      showIcon
      small
      [tooltip]="tooltipIstatSendStatus"
      tooltipTrigger="click"
      [tooltipContext]="{ row: row }"
      [disabled]="false"
    />
  } @else {
    <ds-status-label [text]="translation.status.type.unknown" status="light-dark" showIcon small />
  }
</ng-template>

<ng-template #tooltipIstatCompleteStatus let-row="row">
  @let customerErrors = getCustomerErrors(row.id);
  <p>
    <b>{{ translation.tooltip.error.detail }}</b>
  </p>
  @for (customerError of customerErrors; track $index) {
    <div>
      <span>{{ customerError.name }}:</span>
      <ul>
        @for (error of customerError.errors; track $index) {
          @if (error) {
            <li>{{ translationService.translateError(error) }}</li>
          }
        }
      </ul>
      <br />
    </div>
  }
</ng-template>

<ng-template #tooltipIstatSendStatus let-row="row">
  @let tooltip = getSendIstatTooltip(row);

  @if (tooltip) {
    <div>
      <div>
        <b>{{ tooltip.customerSendStatus.name }}</b
        ><br />
        {{ tooltip.customerSendStatus.statusDescription }}
      </div>

      @if (tooltip.customerSendStatus.statusHasError) {
        <div>
          @if (tooltip.customerSendStatus.statusHasError.ErrorCode) {
            <div>
              <b>{{ translation.tooltip.error.description }}:</b>
              {{ tooltip.customerSendStatus.statusHasError.ErrorCode }}
            </div>
          }
          @if (tooltip.customerSendStatus.statusHasError.ErrorDescription) {
            <div>
              <b>{{ translation.tooltip.error.description }}:</b>
              {{ tooltip.customerSendStatus.statusHasError.ErrorDescription }}
            </div>
          }
          @if (tooltip.customerSendStatus.statusHasError.ErrorDetail) {
            <div>
              <b>{{ translation.tooltip.error.description }}:</b>
              {{ tooltip.customerSendStatus.statusHasError.ErrorDetail }}
            </div>
          }
        </div>
      }
    </div>

    @let relatives = tooltip.relativesSendStatus;
    @if (relatives && relatives.length > 0) {
      <br />
      <div>
        <p>
          <b
            ><i>{{ translation.status.type.relatives }}:</i></b
          >
        </p>
        @for (relative of relatives; track $index) {
          <div>
            <b>{{ relative.name }}</b
            ><br />
            {{ relative.statusDescription }}
          </div>
          @if (relative.statusHasError) {
            <div>
              @if (relative.statusHasError.ErrorCode) {
                <div>
                  <b>{{ translation.tooltip.sendStatus.errorCode }}:</b> {{ relative.statusHasError.ErrorCode }}
                </div>
              }
              @if (relative.statusHasError.ErrorDescription) {
                <div>
                  <b>{{ translation.tooltip.error.description }}:</b>
                  {{ relative.statusHasError.ErrorDescription }}
                </div>
              }
              @if (relative.statusHasError.ErrorDetail) {
                <div>
                  <b>{{ translation.tooltip.error.detail }}:</b> {{ relative.statusHasError.ErrorDetail }}
                </div>
              }
            </div>
          }
        }
      </div>
    }
  }
</ng-template>
